module.exports = __webpack_public_path__ + "img/temb6.4759b6fb.png";